import {
  Banner,
  Box,
  ModalBody,
  ModalFoot,
  Text,
} from '@dixa/lib-shared-habla';
import flatten from 'lodash/flattenDeep';
import { useState } from 'react';

import { useMigrateOpeningHoursContext } from '../../migrateOpeningHours.context';

import { Edit } from './components/edit/edit';
import { Overview } from './components/overview/overview';

export function ReviewHours(): JSX.Element {
  const [isEditViewActive, setIsEditViewActive] = useState(false);
  const { intervalsErrors, schedule, timezone, onCancel, onNextStep } =
    useMigrateOpeningHoursContext();

  const handleSetEditView = () => setIsEditViewActive(true);

  // Check if there is an intervals error
  const hasError = flatten(intervalsErrors).some((error) => !!error?.length);

  return (
    <>
      <ModalBody>
        <Text.Paragraph subdued variant="2">
          Check to make sure that these business hours are still correct and
          edit if necessary.
        </Text.Paragraph>
        <Box margin="400 0">
          <Banner
            icon="hamburger"
            variant="announcement"
            description={
              <Text.Paragraph variant="4">
                You can now create several time slots per day, e.g. for lunch
                breaks!
              </Text.Paragraph>
            }
          />
        </Box>
        {isEditViewActive ? (
          <Edit schedule={schedule} />
        ) : (
          <Overview
            schedule={schedule}
            timezone={timezone}
            onEdit={handleSetEditView}
          />
        )}
      </ModalBody>
      <ModalFoot
        cancelOnClick={onCancel}
        confirmName="Continue to holidays"
        confirmOnClick={onNextStep}
        confirmProps={{
          disabled: hasError,
        }}
      />
    </>
  );
}
